'use client'

import { Fragment } from 'react'
import { Button, Spacer, Image, Icon } from '@vinted/web-ui'
import { X12 } from '@vinted/monochrome-icons'

import { MediaUploadPhotoDto } from '@marketplace-web/item-upload/media-upload-data'

type Props = {
  images: Array<MediaUploadPhotoDto>
  onImageRemove: (image: MediaUploadPhotoDto) => () => void
}

const ImagePreview = ({ images, onImageRemove }: Props) => {
  const renderRemoveButton = (image: MediaUploadPhotoDto) => (
    <div className="image-preview__image-remove">
      <Button
        icon={<Icon name={X12} color={Icon.Color.GreyscaleLevel3} />}
        size={Button.Size.Small}
        inverse
        styling={Button.Styling.Filled}
        inline
        testId="image-preview-remove-button"
        onClick={onImageRemove(image)}
      />
    </div>
  )

  const renderImages = (): Array<JSX.Element> => {
    return images.map((image, index) => (
      <Fragment key={image.id}>
        <div className="image-preview__image">
          <Image
            src={image.full_size_url}
            styling={Image.Styling.Rounded}
            size={Image.Size.X2Large}
          />
          {renderRemoveButton(image)}
        </div>
        {images.length - 1 !== index && <Spacer orientation={Spacer.Orientation.Vertical} />}
      </Fragment>
    ))
  }

  return <div className="image-preview">{renderImages()}</div>
}

export default ImagePreview
